import React from "react";
import { useStyles } from "./ButtonsStyles.css";
import { Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

const PlayButton = ({ onButtonClick, isLoading }) => {
    const classes = useStyles();

    return (
        <Button className={classes.videoPlayerStartBtn} onClick={onButtonClick}>
            {!isLoading && (
                <div style={{
                    display: "contents",
                }}>
                    <PlayCircleOutlineIcon className={classes.icon} />
                    <Typography>
                        {" "}
                        <FormattedMessage
                            id={"app.game.buttons.play"}
                            defaultMessage={"Play Scene"}
                        />
                    </Typography>
                </div>
            )}
            {isLoading && (
                <div style={{
                    display: "contents",
                }}>
                    <CircularProgress size={50}/>
                    <Typography style={{
                        paddingLeft: "14px",
                    }}>
                        <FormattedMessage
                            id={"app.game.buttons.loading"}
                            defaultMessage={"Loading..."}
                        />
                    </Typography>
                </div>
            )}
        </Button>
    );
};

export default PlayButton;
